import { useFetcher } from '@remix-run/react'
import { type GetAddresses } from '~/models/ecommerce-providers/sylius/shop/fetch/address/get-addresses'
import { PROFILE_ADDRESSES_CREATE_FORM } from '~/routes/($lang).profile.addresses.create/create.component'

type useOptimisticAddressesProps = {
	addresses?: GetAddresses
	addressesLoaderData: GetAddresses
}

function useOptimisticAddresses({
	addresses,
	addressesLoaderData,
}: useOptimisticAddressesProps) {
	const createAddressFetcher = useFetcher({
		key: PROFILE_ADDRESSES_CREATE_FORM.subaction,
	})

	return {
		...(addresses || addressesLoaderData),
		items: [
			...(addresses?.items || addressesLoaderData.items!),
			...(createAddressFetcher.formData
				? [
						{
							...Object.fromEntries(createAddressFetcher.formData.entries()),
							'@id': '-1',
							id: -1,
						},
					]
				: []),
		],
	}
}

export { useOptimisticAddresses }
